/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, CircularProgress } from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ButtonFilled } from '../../components/Button/Button';
import { getServices } from '../../config/config';
import LogoColor from '../../images/Evalue8-300px.png';

type Status = 'verifying' | 'success' | 'error';

function VerifyEmail() {
  const apiPrefix = getServices().serviceURL;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<Status>('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const accountId = searchParams.get('account_id');
    const code = searchParams.get('code');

    if (!accountId || !code) {
      setStatus('error');
      setMessage('Invalid verification link. Please request a new one.');
      return;
    }

    const verify = async () => {
      try {
        await axios.post(
          `${apiPrefix}/accounts_verify/verify_email?account_id=${accountId}`,
          { code },
        );
        setStatus('success');
      } catch (error: any) {
        setStatus('error');
        const errData = error?.response?.data;
        if (errData?.error?.message) {
          setMessage(errData.error.message);
        } else if (typeof errData === 'string') {
          setMessage(errData);
        } else {
          setMessage('Verification failed. Please request a new link.');
        }
      }
    };

    verify();
  }, []);

  return (
    <div style={{
      display: 'flex', justifyContent: 'center', alignItems: 'flex-start', minHeight: '100vh', paddingTop: '100px',
    }}
    >
      <Card sx={{ width: '500px', padding: '50px', borderRadius: '10px' }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <Link to="/">
            <img src={LogoColor} alt="" />
          </Link>
        </div>

        {status === 'verifying' && (
          <div style={{ textAlign: 'center' }}>
            <CircularProgress />
            <p style={{ marginTop: '20px' }}>Verifying your email...</p>
          </div>
        )}

        {status === 'success' && (
          <>
            <p style={{ fontSize: '16px' }}>Your email has been verified successfully.</p>
            <br />
            <ButtonFilled handleSubmit={() => navigate('/')}>Go to login</ButtonFilled>
          </>
        )}

        {status === 'error' && (
          <>
            <p style={{ fontSize: '16px', color: '#d32f2f' }}>{message}</p>
            <br />
            <ButtonFilled handleSubmit={() => navigate('/')}>Go to login</ButtonFilled>
          </>
        )}
      </Card>
    </div>
  );
}

export default VerifyEmail;
